/**
 * @param  {*} x value
 * @return {boolean} isFalse
 *
 * @since 4.0.0-alpha.1
 * @memberOf is
 * @func isFalse
 *
 * @example
 *
 *  isFalse(false)
 *  //=> true
 *  isFalse(true)
 *  //=> false
 *  isFalse(0)
 *  //=> false
 *  isFalse('')
 *  //=> false
 *
 */
module.exports = function isFalse(x) {
  return x === false
}

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmFsc2UuanMiLCJzb3VyY2VzIjpbImZhbHNlLmpzIl0sInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogQHBhcmFtICB7Kn0geCB2YWx1ZVxuICogQHJldHVybiB7Ym9vbGVhbn0gaXNGYWxzZVxuICpcbiAqIEBzaW5jZSA0LjAuMC1hbHBoYS4xXG4gKiBAbWVtYmVyT2YgaXNcbiAqIEBmdW5jIGlzRmFsc2VcbiAqXG4gKiBAZXhhbXBsZVxuICpcbiAqICBpc0ZhbHNlKGZhbHNlKVxuICogIC8vPT4gdHJ1ZVxuICogIGlzRmFsc2UodHJ1ZSlcbiAqICAvLz0+IGZhbHNlXG4gKiAgaXNGYWxzZSgwKVxuICogIC8vPT4gZmFsc2VcbiAqICBpc0ZhbHNlKCcnKVxuICogIC8vPT4gZmFsc2VcbiAqXG4gKi9cbm1vZHVsZS5leHBvcnRzID0gZnVuY3Rpb24gaXNGYWxzZSh4KSB7XG4gIHJldHVybiB4ID09PSBmYWxzZVxufVxuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQW9CQSxNQUFNLENBQUMsT0FBTyxHQUFHLFNBQVMsT0FBTyxDQUFDLENBQUMsRUFBRTtFQUNuQyxPQUFPLENBQUMsS0FBSyxLQUFLO0NBQ25COyJ9